import { atom, DefaultValue, selector } from "recoil";
import dayjs from "dayjs";

import {
  alarmType,
  toastInputType,
  toastType,
  getProjectAlarms,
  getUserAlarms,
} from "lib/store/common";
import {
  aspectListState,
  currentSelected,
  selectedAspect,
  threadListState,
} from "lib/store/dashboard";
import { currentProject } from "lib/store/project";
import { aspectPageState } from "lib/store/sentiment";
import { threadPageState } from "lib/store/thread/";

export const toastListState = atom({
  key: "TOAST/list",
  default: [] as toastType[],
});

//토스트 지우기
export const toastRemoveState = selector({
  key: "Toast/delete",
  get: ({ get }) => [...get(toastListState)],
  set: ({ set }, newValue) => {
    set(toastListState, (_) => _.filter((i) => i.idx !== newValue));
  },
});

// 토스트 자동생성
export const errorToastState = selector<toastType[]>({
  key: "Toast/error_set",
  get: ({ get }) => [...get(toastListState)],
  set: ({ get, set }, newValue) => {
    const makeToast = (): toastType[] => {
      const val: string[] = Object.values(newValue);
      const list = get(toastListState);
      return val.map((text) => ({
        type: "error",
        text,
        idx: list.length === 0 ? 0 : list[list.length - 1].idx + 1,
      }));
    };
    set(toastListState, (toast) => [...toast, ...makeToast()]);
  },
});

// 토스트 만들기
export const customToastState = selector<toastInputType>({
  key: "Toast/set",
  get: ({ get }) => get(toastListState)[0],
  set: ({ get, set }, newValue) => {
    const list = get(toastListState);
    if (!(newValue instanceof DefaultValue)) {
      set(toastListState, (toast) => [
        ...toast,
        {
          type: newValue.type,
          text: newValue.text,
          idx: list.length === 0 ? 0 : list[list.length - 1].idx + 1,
        },
      ]);
    }
  },
});

// date 수정시 자세히보기 reset 하게 만듦.

export const dateAtom = atom({
  key: "DATE/atom",
  default: {
    moveMonth: 1,
    range: {
      first: dayjs().subtract(1, "month"),
      last: dayjs().add(1, "day"),
    },
  },
});

export const dateState = selector<{
  moveMonth: number;
  range: { first: dayjs.Dayjs; last: dayjs.Dayjs };
}>({
  key: "DATE/selector",
  get: ({ get }) => get(dateAtom),
  set: ({ reset, set }, newValue) => {
    reset(currentSelected);
    set(dateAtom, newValue);
  },
});

//알람리셋

export const alarmRefresh = atom({
  key: "ALARM/refresh",
  default: new Date(),
});

//전체알람

export const asyncAlarmState = selector({
  key: "ALARM/get_user_alarm",
  get: async ({ get }) => {
    get(alarmRefresh);

    let returnVal: alarmType[] = [];
    try {
      returnVal = [...(await getUserAlarms()).results];
    } catch (e) {
      console.log(e);
    }

    return returnVal;
  },
});

//프로젝트 알람
export const asyncProjectAlarmState = selector({
  key: "ALARM/get_project_alarm",
  get: async ({ get }) => {
    get(alarmRefresh);

    const pid = get(currentProject);

    if (pid === 0 || isNaN(pid)) return [];

    let returnVal: alarmType[] = [];

    try {
      returnVal = [...(await getProjectAlarms(pid)).results];
    } catch (e) {
      console.log(e);
    }

    return returnVal;
  },
});

//프로젝트 이동시 recoil state 리셋
export const resetState = selector({
  key: "common/reset",
  get: (res) => res,
  set: ({ reset }) => {
    reset(modalState);
    reset(dateState);
    reset(selectedAspect);
    reset(currentSelected);
  },
});

//날짜 변경시 recoil state 리셋
export const dateReset = selector({
  key: "common/date_reset",
  get: (res) => res,
  set: ({ reset, set }) => {
    set(aspectPageState, 1);
    set(threadPageState, 1);
    reset(aspectListState);
    reset(threadListState);
  },
});

//모달 온/오프
export const modalState = atom({
  key: "modal",
  default: {
    myAccount: false,
    changePassword: false,
    pp: false,
    term: false,
    market: false,
    categorySelect: false,
    requestCategory: false,
    addCard: false,
    refundDetail:false,
  },
});
